export default __webpack_public_path__ + "static/media/ox.154556b9.png";